var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditOn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#EFEFEF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4728 9.66159L14.3334 7.51418L14.8987 6.94978C14.9919 6.85536 15.1038 6.78148 15.2272 6.73288C15.3507 6.68428 15.4829 6.66204 15.6155 6.66758C15.7487 6.66661 15.8807 6.6923 16.0038 6.74314C16.1269 6.79397 16.2386 6.86891 16.3323 6.96356L17.0492 7.69328C17.1429 7.78406 17.2166 7.8935 17.2654 8.01452C17.3143 8.13555 17.3372 8.26547 17.3327 8.3959C17.3327 8.52681 17.3065 8.65639 17.2556 8.77699C17.2046 8.89759 17.1301 9.00677 17.0363 9.09807L16.4728 9.66159ZM7.16319 17.3331C7.09664 17.3357 7.03029 17.3242 6.96849 17.2994C6.90669 17.2746 6.85082 17.237 6.80455 17.1891C6.75948 17.1426 6.7241 17.0876 6.70045 17.0273C6.6768 16.9671 6.66535 16.9027 6.66678 16.838V15.3914C6.66673 15.3279 6.67849 15.2649 6.70145 15.2056C6.72439 15.1462 6.75968 15.0923 6.805 15.0474L13.7681 8.09281L15.9052 10.226L8.95596 17.182C8.90896 17.2313 8.85281 17.271 8.79063 17.2988C8.73422 17.3219 8.6738 17.3335 8.61287 17.3331H7.16319Z",
    fill: "#525252"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditOn);
export default __webpack_public_path__ + "static/media/editOn.b4a597c37b801ddcc6d77a947e95841d.svg";
export { ForwardRef as ReactComponent };